import { render, staticRenderFns } from "./CounselingEvents.vue?vue&type=template&id=7c2bb7f0&"
import script from "./CounselingEvents.vue?vue&type=script&lang=js&"
export * from "./CounselingEvents.vue?vue&type=script&lang=js&"
import style0 from "./CounselingEvents.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports